import styled from 'styled-components';

import DispatchingListItem from './DispatchingListItem';

import { listItemStyles } from 'modules/fleet/list';

export default styled(DispatchingListItem)`
  ${listItemStyles}

  &.light {
    &,
    &:hover {
      opacity: 0.5;
    }
  }

  &.selected {
    &,
    &:hover {
      .cell {
        background-color: var(--grey100);
      }
      .cell__dark {
        background-color: var(--grey200);
      }
    }
  }

  .pointer {
    cursor: pointer;
  }
`;
